import {
  Flex,
  Paper,
  Title,
  Text,
  Button,
  Image,
  Skeleton,
  Affix,
  Box,
} from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";
import { usePOAStepsStore } from "../../../hooks/ui/poaStepsDataStore";
import FullmaktskollenImage from "/fullmaktskollen-logo.png";
import { useGetFetchPOAText } from "../../../hooks/api";
import BankIDLogo from "../../../assets/bank-id-logo.svg";

export default function POASign() {
  const { customerPOAData } = useUpdateCustomerPOAData();
  const { nextStep, prevStep } = usePOAStepsStore();

  const { data, isSuccess, isLoading, isError } = useGetFetchPOAText({
    credentials: customerPOAData.credentials,
  });

  return (
    <Flex justify="center" align="center" mt={"2rem"} p={"xl"}>
      <Flex direction="column" maw={672} w={"100%"}>
        <Title order={2} mb="sm" ff={"var(--wallet-font-family-subjecttivity)"}>
          Se över dina uppgifter och skriv under med BankID.
        </Title>
        <Text mb={"lg"}>
          Du har alltid möjlighet att ändra dina uppgifter på
          Fullmaktskollen.se.
        </Text>
        <Paper p={30} radius={"24px"} mb={"2rem"}>
          <Title
            order={3}
            mb={"1rem"}
            ff={"var(--wallet-font-family-subjecttivity)"}
          >
            Fullmaktssuppgifter
          </Title>
          <Title
            order={6}
            style={{ color: "var(--wallet-color-sambla-group-neutrals-500)" }}
          >
            <FormattedMessage
              id="poaSign.detailsCard.email"
              defaultMessage="Email"
            />
          </Title>
          <Text mb={"1rem"}>{customerPOAData.email}</Text>
          <Title
            order={6}
            style={{ color: "var(--wallet-color-sambla-group-neutrals-500)" }}
          >
            Telefon
          </Title>
          <Text mb={"1rem"}>{customerPOAData.phoneNumber}</Text>

          <Title
            order={6}
            style={{ color: "var(--wallet-color-sambla-group-neutrals-500)" }}
          >
            Fullmaktens giltighetstid
          </Title>
          <Text mb={"1rem"}>
            {customerPOAData.validTo === null
              ? "Tillsvidare"
              : new Date(customerPOAData.validFrom).toDateString()}
            {customerPOAData.validTo && (
              <> - {new Date(customerPOAData.validTo).toDateString()}</>
            )}
          </Text>

          <Title
            order={6}
            style={{ color: "var(--wallet-color-sambla-group-neutrals-500)" }}
          >
            Fullmaktshavare
          </Title>
          <Text mb={"1rem"}>556974-8378, Sambla Group AB</Text>

          <Title
            order={6}
            style={{ color: "var(--wallet-color-sambla-group-neutrals-500)" }}
          >
            Fullmaktsgivare
          </Title>
          <Text mb={"1rem"}>
            {customerPOAData.personalNumber}, {customerPOAData.name}
          </Text>
          {isLoading && (
            <>
              <Skeleton h={"20px"} mb={"xs"} />
              <Skeleton h={"20px"} width={"30%"} mb={"xs"} />
              <Skeleton h={"20px"} width={"30%"} mb={"xs"} />
              <Skeleton h={"20px"} width={"30%"} mb={"xs"} />
              <Skeleton h={"20px"} mb={"xs"} />
              <Skeleton h={"20px"} mb={"xs"} />
              <Skeleton h={"20px"} mb={"xs"} />
            </>
          )}
          {isSuccess && data && (
            <div dangerouslySetInnerHTML={{ __html: data.signText }}></div>
          )}
          {isError && <>error</>}
        </Paper>
        <Paper p={30} radius={"24px"} mb="2rem">
          <Title
            order={5}
            mb={"1rem"}
            ff={"var(--wallet-font-family-subjecttivity)"}
          >
            Så hanteras personuppgifter inom Fullmaktskollen
          </Title>
          <Text mb={"1rem"} style={{ wordBreak: "break-word" }}>
            Fullmaktskollen i Sverige AB behandlar dina personuppgifter, ditt
            namn, ditt personnummer, din e-postadress och ditt mobilnummer.
            Fullmaktskollen behandlar också de personuppgifter som framgår i
            dina fullmakter. All behandling av dina personuppgifter sker i
            enlighet med gällande lagstiftning. Syftet med behandlingen är att
            kunna tillhandahålla tjänsten. För utförligare information om vilka
            behandlingar som sker av dina personuppgifter se
            www.fullmaktskollen.se/personuppgifter.
          </Text>
          <Flex justify={"center"}>
            <Image
              src={FullmaktskollenImage}
              alt="Fullmaktskollen"
              h={38}
              w="auto"
              fit="contain"
            />
          </Flex>
        </Paper>

        <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
          <Flex justify={"center"} gap={"md"}>
            <Button onClick={() => prevStep()} variant="outline">
              Tillbaka
            </Button>
            <Button onClick={() => nextStep()} disabled={isLoading}>
              Signera
              <Box ml={"sm"}>
                <BankIDLogo />
              </Box>
            </Button>
          </Flex>
        </Affix>
      </Flex>
    </Flex>
  );
}
